import { Board, UserRef } from '@/tracker/types';

export const NO_ESTIMATE = '';

export type BoardSettingsFormValues = {
  name: string;
  estimateBy: NonNullable<Board['estimateBy']> | typeof NO_ESTIMATE;
  owner: UserRef | null;
  /** columnId, а не id: id занят ключами useFieldArray */
  columns: { columnId?: string; name: string; statuses: string[] }[];
};
